// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1RrE4","containerItemsCenter":"Skeleton_containerItemsCenter__3d2XO"};